export default __webpack_public_path__ + "d303cb78dce5846cd88f4ea43ae6b7cb.png";